// @flow
import React, { useCallback } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { withRouter } from 'react-router-dom';
import { TableRow, TableRowColumn } from 'material-ui/Table';

const ConfigurableBlockListItem = props => {
	const { history, block } = props;

	const redirect = useCallback(() => history.push(`/configurable-blocks/${block.id}`), [history]);

	return (
		<TableRow onClick={redirect} style={{ border: 0 }}>
			<TableRowColumn>{block.type}</TableRowColumn>
			<TableRowColumn>{block.slug}</TableRowColumn>
			<TableRowColumn>{block.active ? 'Активный' : 'Неактивный'}</TableRowColumn>
		</TableRow>
	);
};

export default withRouter(
	createFragmentContainer(ConfigurableBlockListItem, {
		block: graphql`
			fragment ConfigurableBlockListItem_block on ConfigurableBlock {
				id
				type
				slug
				config
				active
			}
		`,
	}),
);



// WEBPACK FOOTER //
// src/components/configurable-blocks/ConfigurableBlockListItem.js